import { render, staticRenderFns } from "./AiTask.vue?vue&type=template&id=f2955fe4&scoped=true&"
import script from "./AiTask.vue?vue&type=script&lang=js&"
export * from "./AiTask.vue?vue&type=script&lang=js&"
import style0 from "./AiTask.vue?vue&type=style&index=0&id=f2955fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2955fe4",
  null
  
)

export default component.exports